module.exports = __webpack_public_path__ + "static/media/main idea.cadaef78.mp3";